import { ElPopover, type PopoverProps } from 'element-plus'
import { defineComponent } from 'vue'
import './HocElPopover.scss'

type ElPopoverProps = Partial<PopoverProps> & {
  modelValue?: boolean
  'onUpdate:modelValue'?: (val: boolean) => void
  onHide?: () => void
  onShow?: () => void
}

export const HocElPopover = defineComponent(
  (_: Partial<ElPopoverProps>, { slots, attrs }) => {
    const popoverRef = ref<InstanceType<typeof ElPopover>>()
    return () => (
      <div class="hoc-el-popover-layout">
        <ElPopover {...attrs} ref={popoverRef}>
          {{
            default: () => (
              <div onClick={() => popoverRef.value?.hide()} style={{ height: '100%' }}>
                {slots?.default?.()}
              </div>
            ),
            reference: () => slots?.reference?.(),
          }}
        </ElPopover>
      </div>
    )
  },
  {
    name: 'HocElPopover',
    inheritAttrs: false,
  },
)
